<template>
  <div class="md-toolbar-section-end">
    <md-button to="export" v-if="showLink('export')">
      export
    </md-button>
    <md-button to="/" v-if="showLink('overview')">
      overview
    </md-button>
    <md-button to="recommend" v-if="showLink('share')">
      share
    </md-button>
    <md-menu :md-active.sync="userActions" :md-offset-y="30">
      <md-menu-content>
        <md-menu-item to="settings">
          <md-icon>account_circle</md-icon>
          <span>Profile</span>
        </md-menu-item>
        <md-menu-item to="settings">
          <md-icon>settings</md-icon>
          <span>Settings</span>
        </md-menu-item>
        <md-divider></md-divider>
        <md-menu-item to="/" @click="signOut">
          <md-icon>exit_to_app</md-icon>
          <span>Sign Out</span>
        </md-menu-item>
      </md-menu-content>
    </md-menu>

    <md-button v-if="showLink('account')" class="md-icon-button" to="account">
      <md-avatar>
        <img v-if="user.photoURL && isKnownUser" :src="user.photoURL" alt="Avatar" />
        <md-icon v-else class="">account_circle</md-icon>
      </md-avatar>
    </md-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { navigate, translate } from "../../mixins";

export default {
  name: "Topbarmenu",
  mixins: [navigate, translate],
  props: {
    showLinks: { type: Array, default: () => [] }
  },
  components: {},
  computed: {
    ...mapGetters(["isKnownUser"]),
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    showLink(link) {
      return this.showLinks ? this.showLinks.includes(link) : false;
    },
    signOut() {
      this.$store.dispatch("logout");
    }
  },
  data() {
    return {
      userActions: false
    };
  }
};
</script>

<style lang="scss" scoped>
.md-avatar {
  .md-icon.md-icon-font {
    width: 40px;
    height: 40px;
    font-size: 40px !important;
  }
}
</style>
